import { Icon as IconifyIcon } from '@iconify/react'
import { useSet, useLastResolved, useGet } from 'ccstate-react'
import { wordDetailInstances } from '../state'
import { toggleFavorite$ } from '../commands'
import { navigateInReact$ } from '../infra/router/navigate'
import { sharedLocationState } from '../state'
export default function WordDetailPage() {
  const pathname = useGet(sharedLocationState.pathname$)
  const wordParam = pathname.split('/word/')[1] || ''
  const wordDetail = useLastResolved(wordDetailInstances.getState({ word: wordParam }).wordDetail$)
  const isFavorite = useLastResolved(wordDetailInstances.getState({ word: wordParam }).isFavorite$) || false
  const navigate = useSet(navigateInReact$)
  const toggleFavoriteAction = useSet(toggleFavorite$)
  const handleBack = () => {
    navigate('/')
  }
  const handleToggleFavorite = async () => {
    if (!wordDetail)
      return
    await toggleFavoriteAction({
      wordId: wordDetail.id,
      word: wordDetail.word,
      partOfSpeech: wordDetail.definitions[0]?.partOfSpeech || '',
      briefMeaning: wordDetail.definitions[0]?.meaning || '',
      isFavorite
    })
  }
  if (!wordDetail) {
    return (<div className="min-h-screen bg-[#F7F8FA] p-4" data-id="464qqv">
      <div className="flex items-center mb-6" data-id="9askxu">
        <button onClick={handleBack} data-testid="back-button" data-id="862pwo">
          <IconifyIcon icon="lucide:arrow-left" className="text-2xl text-[#1E3A5F]" data-id="pmhupu"/>
        </button>
      </div>
      <div className="flex flex-col items-center justify-center mt-32" data-id="lq39mh">
        <IconifyIcon icon="lucide:alert-circle" className="text-[80px] text-[#D4DBE6] mb-4" data-id="h1telv"/>
        <p className="text-base text-[#5A6B7D]" data-id="h2tj2o">未找到该单词</p>
      </div>
    </div>)
  }
  return (<div className="min-h-screen bg-[#F7F8FA]" data-id="ydp2ir">
    {/* Top Navigation Bar */}
    <div className="flex items-center justify-between p-4 border-b-2 border-[#D4DBE6] bg-[#F7F8FA]" data-id="0z3fva">
      <button onClick={handleBack} data-testid="back-button" data-id="qxwboy">
        <IconifyIcon icon="lucide:arrow-left" className="text-2xl text-[#1E3A5F]" data-id="t4fohr"/>
      </button>
      <button onClick={handleToggleFavorite} data-testid="favorite-button" data-id="fhkwuy">
        <IconifyIcon icon={isFavorite ? 'lucide:star' : 'lucide:star'} className={`text-2xl ${isFavorite ? 'text-[#F39C12]' : 'text-[#9BA8B8]'}`} style={{ fill: isFavorite ? '#F39C12' : 'none' }} data-id="q9h2hf"/>
      </button>
    </div>

    <div className="p-4" data-id="h1ouwq">
      {/* Word Title Section */}
      <div className="border border-[#D4DBE6] rounded-md bg-[#F7F8FA] p-5 mb-4" data-id="46urqv">
        <h1 className="text-[26px] font-semibold text-[#1A1A1A] mb-2" data-testid="word-title" data-id="8ibnos">
          {wordDetail.word}
        </h1>
        <div className="flex items-center" data-id="gm31ik">
          <span className="text-sm text-[#5A6B7D] mr-3" data-id="uirtho">{wordDetail.phonetic}</span>
          {wordDetail.audioUrl && (<button className="w-8 h-8 border-[1.5px] border-[#1E3A5F] rounded-full flex items-center justify-center" data-testid="play-audio-button" data-id="gr912w">
            <IconifyIcon icon="lucide:volume-2" className="text-base text-[#1E3A5F]" data-id="vymhex"/>
          </button>)}
        </div>
      </div>

      {/* Definitions Section */}
      <div className="border border-[#D4DBE6] rounded-md bg-[#F7F8FA] p-5 mb-4" data-id="453qut">
        <h2 className="text-xl font-medium text-[#1A1A1A] mb-4 pb-4 border-b border-[#E8EDF3]" data-id="z9twlu">释义</h2>
        <div className="space-y-3" data-id="l400ig">
          {wordDetail.definitions.map((def, index) => (<div key={index} className="flex" data-id="ta1f1r">
            <div className="border border-[#1E3A5F] rounded px-2 py-0.5 mr-3 flex-shrink-0" data-id="7k8usn">
              <span className="text-sm font-medium text-[#1E3A5F]" data-id="kyptml">
                {def.partOfSpeech}
              </span>
            </div>
            <span className="text-base text-[#1A1A1A]" data-id="stu18p">{def.meaning}</span>
          </div>))}
        </div>
      </div>

      {/* Examples Section */}
      {wordDetail.examples.length > 0 && (<div className="border border-[#D4DBE6] rounded-md bg-[#F7F8FA] p-5" data-id="0vt438">
        <h2 className="text-xl font-medium text-[#1A1A1A] mb-4 pb-4 border-b border-[#E8EDF3]" data-id="6auyat">例句</h2>
        <div className="space-y-4" data-id="970jpc">
          {wordDetail.examples.map((example, index) => (<div key={index} className="pl-3 border-l-2 border-[#E8EDF3] space-y-2" data-id="2l4t4k">
            <p className="text-base text-[#1A1A1A] italic" data-id="ild5cu">
              {example.english}
            </p>
            <p className="text-base text-[#5A6B7D]" data-id="dagrqq">
              {example.chinese}
            </p>
          </div>))}
        </div>
      </div>)}
    </div>
  </div>)
}
